import React from 'react';
import { BRAND } from '../../config/brand';
import { useAdminStore } from '@/admin/adminStore';
import styles from './BrandMark.module.css';

/**
 * Reusable BrandMark component
 * Props:
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - stacked: boolean (default: false)
 * - schoolFirst: boolean (default: false, swaps school to top for formal receipts)
 * - showSchool: boolean (default: true)
 * - className: string
 */
export function BrandMark({
  size = 'md',
  stacked = false,
  schoolFirst = false,
  showSchool = true,
  className = ''
}) {
  const store = useAdminStore();
  const override = store.brandOverride;
  const primary = schoolFirst
    ? (override?.schoolName || BRAND.schoolName)
    : (override?.productName || BRAND.productName);
  const secondary = schoolFirst
    ? (override?.productName || BRAND.productName)
    : (override?.schoolName || BRAND.schoolName);
  const logoText = override?.logoText || BRAND.logoText;

  const classes = [
    styles.brandMark,
    styles[size] || styles.md,
    stacked ? styles.stacked : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className={styles.logoBadge} aria-hidden="true">
        <span>{logoText}</span>
      </div>
      <div className={styles.textGroup}>
        <span className={styles.primaryText}>{primary}</span>
        {showSchool && (
          <span className={styles.secondaryText}>{secondary}</span>
        )}
      </div>
    </div>
  );
}

export default BrandMark;
